import React, { ReactElement, useState } from 'react'
import {
  MAX_NUMBER_OF_GUESTS,
  MIN_NUMBER_OF_GUESTS,
  useWizardSelector,
} from '@/components/ui/wizard/WizardState'
import { useDispatch } from 'react-redux'
import DropDown from '@/components/ui/wizard/filter/DropDown'
import classNames from 'classnames'
import { setNumberOfGuests } from '@/components/ui/wizard/WizardActions'
import { useTranslations } from 'next-intl'
import FilterLabel from '@/components/ui/wizard/filter/FilterLabel'

interface GuestsProps {
  numberOfGuests: number
  setNumberOfGuests: (i: number) => void
}

export function GuestDropDown(): ReactElement {
  const numberOfGuestInStore = useWizardSelector((state) => state.numberOfGuests)
  const [numberOfGuests, setNumberOfGuestsLocalsState] = useState(numberOfGuestInStore)
  const dispatch = useDispatch()
  const t = useTranslations('SearchPage')

  return (
    <DropDown
      apply={() => dispatch(setNumberOfGuests(numberOfGuests))}
      reset={() => {
        setNumberOfGuestsLocalsState(MIN_NUMBER_OF_GUESTS)
      }}
      // resetLabel={<TranslatedClient id="__SEARCH_PAGE_FILTER_OPTION_RESET__" />}
      resetLabel={t('filterOptionReset')}
      id="guests"
    >
      <Guests numberOfGuests={numberOfGuests} setNumberOfGuests={setNumberOfGuestsLocalsState} />
    </DropDown>
  )
}

export default function Guests(props: GuestsProps): ReactElement {
  return (
    <div className="custom-slider mb-6">
      <FilterLabel label="SearchPage.guestDropDownLabel" />
      <div className="flex items-center gap-x-3 text-2xl">
        <button
          className={classNames(
            'flex h-10 w-10 justify-center rounded-[100%] border-2 border-gray-200 text-3xl leading-[35px]',
            { 'text-gray-200': props.numberOfGuests === MIN_NUMBER_OF_GUESTS },
          )}
          onClick={
            props.numberOfGuests > MIN_NUMBER_OF_GUESTS
              ? () => props.setNumberOfGuests(props.numberOfGuests - 1)
              : undefined
          }
        >
          –
        </button>
        <div className="min-w-[28px] text-center">{props.numberOfGuests}</div>

        <button
          className={classNames(
            'flex h-10 w-10 justify-center rounded-[100%] border-2 text-3xl leading-[34px]',
            { 'text-gray-200': props.numberOfGuests >= MAX_NUMBER_OF_GUESTS },
          )}
          onClick={
            props.numberOfGuests < MAX_NUMBER_OF_GUESTS
              ? () => props.setNumberOfGuests(props.numberOfGuests + 1)
              : undefined
          }
        >
          +
        </button>
      </div>
    </div>
  )
}
